/* eslint-disable quotes */
import each from 'lodash-es/each';
import find from 'lodash-es/find';
import escape from 'lodash-es/escape';
import filter from 'lodash-es/filter';
import { formatMoney } from '../../utils/currency';

let theme = window.theme || {};
let Shopify = window.Shopify || {};

const AdmindCartEvent = (products, isQuickView) => {
  const country = window.theme.country_iso;
  const quadpay_country = country === `US`;
  const added_products = [];
  const removed_products = [];
  // const collectionTitle = document.querySelector('[data-collection]');
  // const collectionName = collectionTitle.dataset.collection;
  const shopify_page = window.ShopifyAnalytics.meta.page;
  const shopify_page_type = shopify_page.pageType;
  let listName = '';

  if (document.querySelector('[data-quick-view-container]')) {
    // This doesn't actually work because Quick View is closed before starting this block of code
    if (document.querySelector('[data-collection]')) {
      listName = document
        .querySelector('[data-quick-view-container]')
        .closest('[data-collection]')
        .getAttribute('data-collection');
    } else {
      listName = '';
    }
  } else if (isQuickView) {
    // This should replace the first "if" above successfully. I think that the "if" clause is no longer used.
    listName = window.theme.quickViewCollection || '';
  } else if (shopify_page_type === 'product') {
    if (window.theme.search_page) {
      listName = 'Search';
    } else if (window.theme.recc_product) {
      listName = sessionStorage.getItem('rec_list_name');
    } else if (window.theme.collectionName) {
      listName = window.theme.collectionName;
    } else {
      // if there was not window.theme.collectionName defined,
      // we will go to take collection name by Breadcumbs via.

      // This is helpful in case customer was redirected from a Quick View and end up clicking Product Title link there
      const hasBreadcumbLink = document.querySelector('.Breadcrumb__link>a:last-child');
      listName = hasBreadcumbLink ? hasBreadcumbLink.textContent : '';
    }
  } else if (window.location.pathname === `/cart`) {
    if (document.querySelector('[data-collection]')) {
      listName = document.querySelector('[data-collection]').getAttribute('data-collection');
    }
  } else if (window.theme.collection) {
    // we will go to take the value there if it was
    // This is useful in cases customers open Quick View in PLP
    listName = window.theme.collection;
  } else {
    listName = '';
  }

  each(products, (product) => {
    const color_option = find(product.options_with_values, {
      name: `Color`,
    });
    const product_color = color_option ? color_option.value : ``;
    const size_option = find(product.options_with_values, {
      name: `Size`,
    });
    const product_size = size_option ? size_option.value : ``;

    // Hacky way to find style_number via the image naming convention
    let product_style = '';
    if (product.image.includes(`/`)) {
      let product_image_split = product.image.split(`/`);
      if (product_image_split.length > 1) {
        let product_image_split_last = product_image_split[product_image_split.length - 1];
        if (product_image_split_last.includes(`_`)) {
          let product_image_split_split = product_image_split_last.split(`_`);
          if (product_image_split_split.length > 1) {
            product_style = product_image_split_split[0];
          }
        }
      }
    }
    if (product_style === '') {
      console.warn(`WARNING: Product style is missing for ID: ${product.id}`);
    }
    const admind_product = {
      id: product.product_id,
      variant: product.variant_id,
      style: escape(product_style || ``),
      // category: ,
      subcategory: escape(product.product_type),
      name: escape(product.product_title),
      price: Number((product.price / 100).toFixed(2)),
      originalPrice: Number((product.original_price / 100).toFixed(2)),
      newArrival: false,
      isMarkedDown: product.price < product.original_price,
      quantity: Math.abs(product.quantity),
      subtotal: Number((product.price / 100).toFixed(2)) * Math.abs(product.quantity),
      hasCoupon: product.discounts.length > 0,
      couponDiscountValue: product.total_discount,
      // percentOff: ,
      hasReviews: false,
      reviewCount: 0,
      reviewAverage: 0,
      color: escape(product_color),
      size: escape(product_size),
      showsQuadpay: quadpay_country && Number(product.price) > 1900,
      // defaulting as we don't have access to inventories at this point
      almostGone: false,
      coupon: ``,
    };

    if (product.quantity < 0) {
      return removed_products.push(admind_product);
    }

    return added_products.push(admind_product);
  });

  const dataLayer = window.dataLayer || [];
  const add_to_cart_cta = document.querySelector(`.ProductInfo__add-to-cart button`);

  if (added_products.length) {
    if (listName) {
      dataLayer.push({
        event: `addToCart`,
        add_to_cart_location: (add_to_cart_cta && add_to_cart_cta.dataset.location) || 'cart',
        ecommerce: {
          currencyCode: window.theme.currency_iso || 'USD',
          add: {
            actionField: {
              list: listName,
            },
            products: added_products,
          },
        },
      });
    } else {
      dataLayer.push({
        event: `addToCart`,
        add_to_cart_location: (add_to_cart_cta && add_to_cart_cta.dataset.location) || 'cart',
        ecommerce: {
          currencyCode: window.theme.currency_iso || 'USD',
          add: {
            products: added_products,
          },
        },
      });
    }
  }

  if (removed_products.length) {
    dataLayer.push({
      event: `removeFromCart`,
      ecommerce: {
        currencyCode: window.theme.currency_iso || 'USD',
        remove: {
          products: removed_products,
        },
      },
    });
  }
};

document.addEventListener('cartWillUpdate', function (event) {
  const old_cart = JSON.parse(JSON.stringify(window.cart));

  setTimeout(() => {
    const new_cart = JSON.parse(JSON.stringify(window.cart));
    const changed_items = [];

    each(new_cart.items, (new_item) => {
      const old_item = find(old_cart.items, {
        id: new_item.id,
      });
      if (old_item) {
        new_item.quantity -= old_item.quantity;
        old_item.exists = true;
      }

      if (new_item.quantity) {
        changed_items.push(new_item);
      }
    });

    const removed_items = filter(old_cart.items, (item) => !item.exists);
    if (removed_items.length) {
      each(removed_items, (removed_item) => {
        removed_item.quantity *= -1;
        changed_items.push(removed_item);
      });
    }

    // Detect when event come from a Quick View modal and send it to Admind Cart function
    const isQuickView = event.detail?.quickView;
    AdmindCartEvent(changed_items, isQuickView);

    const template = document.querySelector('[data-template]').getAttribute('data-template');
    if (template == 'cart') {
      window.monetateQ = window.monetateQ || [];
      if (window.cart.items.length < 1) {
        window.monetateQ.push(['setPageType', 'emptycart']);
      } else {
        window.monetateQ.push(['setPageType', 'cart']);
      }

      var cartItems = window.cart.items;

      // Create an array to hold the transformed data
      var cartData = [];
      var cartProductIds = [];

      // Loop through cart items and transform them
      for (var i = 0; i < cartItems.length; i++) {
        var cartItem = cartItems[i];
        var price = formatMoney(cartItem.price, theme.moneyFormat);
        price = price.replace(/[$A-Za-z,\s]+/g, '');
        if (!/^\d/.test(price)) {
          price = price.slice(1);
        }
        var cartItemData = {
          productId: cartItem.product_id.toString(),
          quantity: cartItem.quantity.toString(),
          unitPrice: price,
          currency: Shopify.currency.active.toString(),
          sku: cartItem.variant_id.toString(),
        };
        cartData.push(cartItemData);
        cartProductIds.push(cartItem.product_id.toString());
      }

      window.monetateQ.push(['addCartRows', cartData]);
      window.monetateQ.push(['trackData']);

      window.FastSimonSDK.event({
        eventName: window.FastSimonEventName.AddToCartPerformed,
        reportAppType: 'SPA',
        data: {
          productID: [...cartProductIds], // (Required)
        },
      });
    }
  }, 0);
});

// tracking add a wishlist product to the cart.
document.addEventListener('click', function (e) {
  if (e.target && e.target.classList.contains('addsingleproduct')) {
    const num_variant_in_product = e.currentTarget.getAttribute('data-variant_count');
    if (num_variant_in_product === '1') {
      const product_url = e.currentTarget.getAttribute('data-url');
      const url = `${product_url}.json`;
      fetch(url, { cache: 'no-cache' })
        .then((response) => response.json())
        .then((res) => {
          const product = res.product;
          const country = window.theme.country_iso;
          const quadpay_country = country === `US`;
          // Hacky way to find style_number via the image naming convention
          const product_style = product.image.src.split(`products/`)[1].split(`_`)[0];

          const wish_product = {
            id: product.id,
            variant: product.variants[0].id,
            style: escape(product_style || ``),
            // category: ,
            subcategory: escape(product.product_type),
            name: escape(product.title),
            price: Number(product.variants[0].price),
            originalPrice: Number(product.variants[0].compare_at_price),
            newArrival: false,
            isMarkedDown: Number(product.variants[0].price) < Number(product.variants[0].compare_at_price),
            quantity: 1,
            subtotal: Number(product.variants[0].price),
            hasCoupon: false,
            couponDiscountValue: product.total_discount,
            // percentOff: ,
            hasReviews: false,
            reviewCount: 0,
            reviewAverage: 0,
            color: escape(product.variants[0].option1),
            size: escape(product.variants[0].option2),
            showsQuadpay: quadpay_country && Number(product.variants[0].price) > 19.0,
            // defaulting as we don't have access to inventories at this point
            almostGone: false,
            coupon: ``,
          };

          const dataLayer = window.dataLayer || [];

          dataLayer.push({
            event: `addToCart`,
            ecommerce: {
              currencyCode: window.theme.currency_iso || 'USD',
              add: {
                products: [wish_product],
              },
            },
          });
        });
    }
  }
});

document.addEventListener('cartDidUpdate', function (event) {
  const cart = event.detail;
  const country = window.theme.country_iso;
  const quadpay_country = country === `US`;
  const cart_items = [];

  const shopify_page = window.ShopifyAnalytics.meta.page;
  let shopify_page_type = shopify_page.pageType;
  // Checkout Page Type
  if (!shopify_page_type && shopify_page && shopify_page.path) {
    if (shopify_page.path.indexOf('checkout') > -1) {
      shopify_page_type = `checkout`;
    }
  }
  const admind_page_types = {
    home: `Home`,
    product: `PDP`,
    collection: `Category`,
    page: `Other`,
    checkout: `Checkout`,
    blog: 'Blog',
  };

  const page_type =
    shopify_page_type && admind_page_types[shopify_page_type] ? admind_page_types[shopify_page_type] : `Other`;

  each(cart.items, (product) => {
    const color_option = find(product.options_with_values, {
      name: `Color`,
    });
    const product_color = color_option ? color_option.value : ``;
    const size_option = find(product.options_with_values, {
      name: `Size`,
    });
    const product_size = size_option ? size_option.value : ``;

    // Hacky way to find style_number via the image naming convention
    let product_style = '';
    if (product.image.includes(`/`)) {
      let product_image_split = product.image.split(`/`);
      if (product_image_split.length > 1) {
        let product_image_split_last = product_image_split[product_image_split.length - 1];
        if (product_image_split_last.includes(`_`)) {
          let product_image_split_split = product_image_split_last.split(`_`);
          if (product_image_split_split.length > 1) {
            product_style = product_image_split_split[0];
          }
        }
      }
    }
    if (product_style === '') {
      console.warn(`WARNING: Product style is missing for ID: ${product.id}`);
    }
    const admind_product = {
      id: product.product_id,
      variant: product.variant_id,
      style: escape(product_style || ``),
      // category: ,
      subcategory: escape(product.product_type),
      name: escape(product.title),
      price: Number((product.price / 100).toFixed(2)),
      originalPrice: Number((product.original_price / 100).toFixed(2)),
      newArrival: false,
      isMarkedDown: product.price < product.original_price,
      quantity: Math.abs(product.quantity),
      subtotal: Number(((product.price / 100) * Math.abs(product.quantity)).toFixed(2)),
      hasCoupon: product.discounts.length > 0,
      couponDiscountValue: product.total_discount,
      // percentOff: ,
      hasReviews: false,
      reviewCount: 0,
      reviewAverage: 0,
      color: escape(product_color),
      size: escape(product_size),
      showsQuadpay: quadpay_country && Number(product.price) > 1900,
      // defaulting as we don't have access to inventories at this point
      almostGone: false,
      coupon: ``,
    };

    cart_items.push(admind_product);
  });

  const updated_cart_info = {
    event: `cartUpdate`,
    user: {
      id: window.theme.customerid || ``,
      loggedIn: Boolean(window.theme.customerid),
      lifetimeValue: window.theme.customer_total_spent || 0,
      existingCustomer: window.theme.customerid ? `Yes` : `No`,
      subscribedToNewsletter: window.theme.accepts_marketing === `true` ? `Yes` : `No`,
      freeShippingThreshold: 0,
      specials: [],
      firstName: escape(window.theme.customer_first_name || ``),
      lastName: escape(window.theme.customer_last_name),
      email: escape(window.theme.customer_email || ``),
      email2: ``,
      telephone: escape(window.theme.customer_phone),
      hashedEmail: window.theme.customer_hashedEmail || ``,
    },
    countryCode: country,
    currency: cart.currency,
    page: {
      path: window.location.pathname || ``,
      type: page_type,
      category: page_type,
      ecomm_pagetype: page_type,
    },
    cart: {
      summaryQty: cart.item_count,
      value: cart.total_price,
      currency: cart.currency,
      products: cart_items,
    },
  };

  const dataLayer = window.dataLayer || [];
  dataLayer.push(updated_cart_info);
});
